import {inject, Injectable} from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {SnackBarType} from './snackbar-type.enum';
import {SnackBarComponent} from './snackbar.component';


@Injectable({
    providedIn: 'root'
})
export class SnackBarService
{
    private readonly snackBar = inject(MatSnackBar);

    public show(type: SnackBarType, message: string, duration = 2000): void
    {
        this.snackBar.openFromComponent(SnackBarComponent, {
            duration,
            data: {
                message,
                type
            },
            horizontalPosition: 'end',
            verticalPosition: 'top'
        });
    }

    public showErrorSnackbar(message: string, duration?: number): void
    {
        this.show(SnackBarType.ERROR, message, duration);
    }

    public showWarningSnackbar(message: string, duration?: number): void
    {
        this.show(SnackBarType.WARN, message, duration);
    }

    public showSuccessSnackbar(message: string, duration?: number): void
    {
        this.show(SnackBarType.SUCCESS, message, duration);
    }
}
